(() => {
  const modal = document.querySelector('[data-santo-search-modal]');
  if (!modal) return;
  const input = modal.querySelector('[data-santo-search-input]');
  const results = modal.querySelector('[data-santo-search-results]');
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  const open = () => { modal.hidden = false; document.body.style.overflow = 'hidden'; setTimeout(() => input.focus(), 20); };
  const close = () => { modal.hidden = true; document.body.style.overflow = ''; };
  document.addEventListener('click', (event) => {
    const searchLink = event.target.closest('a[href*="/search"]');
    if (searchLink && searchLink.closest('.santo-header')) { event.preventDefault(); open(); return; }
    if (event.target.closest('[data-santo-search-close]') || event.target === modal) close();
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !modal.hidden) close(); });
  let timer;
  input.addEventListener('input', () => {
    clearTimeout(timer);
    const query = input.value.trim();
    if (query.length < 2) { results.innerHTML = '<div class="santo-search-message">Type at least two letters to search wines.</div>'; return; }
    results.innerHTML = '<div class="santo-search-message">Searching…</div>';
    timer = setTimeout(async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=8`, { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error();
        const products = (await response.json()).resources?.results?.products || [];
        results.innerHTML = products.length ? products.map((product) => `<a class="santo-search-result" href="${escapeHtml(product.url)}"><img src="${escapeHtml(product.image || '')}" alt=""><strong>${escapeHtml(product.title)}</strong><span>${escapeHtml(product.price || '')}</span></a>`).join('') : '<div class="santo-search-message">No matching wines found.</div>';
      } catch (_) { results.innerHTML = '<div class="santo-search-message">Search is temporarily unavailable. Please try again.</div>'; }
    }, 220);
  });
})();

